import * as constants from './constants';
import * as apiHelper from '../../apiHelper';

import { pushError } from '../global/actions';

const onFetchDestinationRequestSent = () => {
  return {
    type: constants.FETCH_DESTINATIONS_REQUEST
  }
}

const onFetchDestinationRequestSuccessful = (data) => {
  return {
    data,
    type: constants.FETCH_DESTINATIONS_SUCCESS
  }
}

const onFetchDestinationRequestFailure = (error) => {
  return {
    type: constants.FETCH_DESTINATIONS_FAILURE,
    data: error
  }
}

export const onDestinationSuggestionsCleared = () => {
  return {
    type: constants.DESTINATIONS_CLEARED
  }
}

export const onDestinationSelected = (destination) => {
  return {
    type: constants.DESTINATION_SELECTED,
    data: destination
  }
}

export const onDestinationFailedValidation = (error) => {
  return {
    type: constants.VALIDATION_ERROR,
    data: error
  }
}

export const fetchDestinationSuggestions = (text) => {
  return (dispatch) => {
    dispatch(onFetchDestinationRequestSent());
    return apiHelper.apiPost('town-search/v2', { text: text.trim() })
      .then(response => response.json())
      .then(json => {
        if (json.error) {
          dispatch(pushError(json.error));
          dispatch(onFetchDestinationRequestFailure(json.error));
          return;
        }
        let data = [];

        data = json.university ? [...data, ...json.university] : data;
        data = json.city ? [...data, ...json.city] : data;

        dispatch(onFetchDestinationRequestSuccessful(data))
      })
  }
}
